module.exports = __webpack_public_path__ + "static/media/estadosunidos.f85c3870.jpg";